import Viewer from "./Viewer"
import Editor from "./Editor"

export default {
    name: "videovr",
    title: "Video 360",
    icon: require("./content-icon.svg"),
    category: "multimedia",
    Viewer,
    Editor,
    Preview: Viewer
}